// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.series_container {
  width: 100%;
  min-height: 100vh;
  background-color: #151018;
  position: relative;
}
.series_container .series_header {
  width: 100%;
  padding: 2rem 1.5rem 0.2rem 1.5rem;
  display: flex;
}
.series_container .series_header .series_logo {
  width: 15%;
  display: flex;
  align-items: center;
  position: relative;
}
.series_container .series_header .series_logo img {
  width: 30%;
  margin-left: 30%;
}
.series_container .series_header .series_logo .back {
  position: absolute;
  right: 0.4rem;
  top: 50%;
  transform: translateY(-50%);
  width: 46.34px;
  height: 46.34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: #FFFFFF;
  background-color: #231B27;
  border: 1px solid #231B27;
  border-radius: 0.4rem;
}
.series_container .series_header .series_logo .back:hover {
  background-color: #2a202e;
  color: rgb(214, 65, 10);
}
.series_container .series_header .series_search {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.series_container .series_header .series_search input {
  width: 100%;
  padding: 0.48rem 3rem;
  outline: none;
  background-color: #231B27;
  border-radius: 0.6rem;
  border: 1px solid #231B27;
  color: #FFFFFF;
  font-size: 1.2rem;
}
.series_container .series_header .series_search input::placeholder {
  color: #898989;
}
.series_container .series_header .series_search span {
  position: absolute;
  display: flex;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.8rem;
  color: #9c9c9c;
}
.series_container .series_header .series_avatar {
  width: 15%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding-left: 0.5rem;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.series_container .series_header .series_avatar .avatar {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #bababa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: 0.1s linear;
}
.series_container .series_header .series_avatar .avatar:hover {
  background-color: #e8e5e5;
  color: rgb(214, 65, 10);
  font-size: 1.5rem;
}
.series_container .series_header .series_avatar .avatar .org {
  position: absolute;
  color: #e8e5e5;
  font-size: 0.8rem;
  text-transform: capitalize;
  font-family: "wildjess";
  top: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
}
.series_container .series_header .series_avatar .notif {
  width: 3.313rem;
  height: 3.313rem;
  background-color: #231B27;
  color: #e8e5e5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: 0.1s linear;
}
.series_container .series_header .series_avatar .notif:hover {
  color: #D91D6F;
  font-size: 1.5rem;
}
.series_container .series_header .series_avatar .notif .num_of_notifs {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #bd2969;
  position: absolute;
  top: -0.3rem;
  left: 80%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  color: black;
}
.series_container .series_header .series_avatar .sub_list {
  width: 80%;
  margin: 0 auto;
  padding: 1rem 0.2rem;
  background-color: #231B27;
  position: absolute;
  bottom: -6.5rem;
  border-radius: 0.6rem;
  z-index: 10;
}
.series_container .series_header .series_avatar .sub_list .item {
  display: block;
  margin: 0.4rem 1rem;
  text-decoration: none;
  color: #FFFFFF;
}
.series_container .series_header .series_avatar .sub_list .item:hover {
  color: rgb(214, 65, 10);
}
.series_container .series_header .series_avatar .notif_list {
  width: 120%;
  height: 50vh;
  margin: 0 auto;
  padding: 1rem 0.6rem;
  background-color: #231B27;
  position: absolute;
  bottom: -50vh;
  left: -40%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 0.6rem;
  z-index: 10;
}
.series_container .series_header .series_avatar .notif_list .nofit_item {
  display: block;
  width: 100%;
  font-size: 0.6rem;
  color: #e8e5e5;
  padding: 0.8rem 0.6rem;
  background-color: #bd2969;
}
.series_container .series_content {
  width: 70%;
  margin: 0 auto;
  padding: 0 1rem;
}
.series_container .series_content h2 {
  color: #FFFFFF;
  margin: 3rem 0;
  font-size: 2rem;
}
.series_container .series_content .series_cards {
  width: 100%;
  padding: 1.5rem 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 2rem;
}
.series_container .series_content .series_cards .add_serie_card {
  width: 17rem;
  height: 25rem;
  border: 1px solid #FFFFFF;
  border-radius: 1.25rem;
  cursor: pointer;
}
.series_container .series_content .series_cards .add_serie_card .add_serie_icon {
  width: 17rem;
  height: 15rem;
  color: #FFFFFF;
  justify-content: center;
  align-items: center;
  font-size: 12rem;
  display: flex;
  transition: 0.2s linear;
}
.series_container .series_content .series_cards .add_serie_card .add_serie_icon:hover {
  color: rgb(214, 65, 10);
}
.series_container .series_content .series_cards .add_serie_card .add_serie_text {
  width: 17rem;
  height: 8rem;
  padding: 1rem;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
}
.series_container .series_content .series_cards .serie_card {
  width: 17rem;
  height: 25rem;
  border: 1px solid #FFFFFF;
  border-radius: 1.25rem;
  background-color: rgb(255, 199, 96);
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  animation: onCreateCard 0.5s forwards ease-in;
}
.series_container .series_content .series_cards .serie_card a {
  display: flex;
  width: 17rem;
  height: 25rem;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  color: rgb(203, 57, 4);
}
.series_container .series_content .series_cards .serie_card .serie_card_details {
  width: 17rem;
  height: 10rem;
  padding-top: 0.5rem;
  background: rgba(46, 44, 52, 0.737254902);
  position: absolute;
  bottom: -12rem;
  transition: 0.2s linear;
}
.series_container .series_content .series_cards .serie_card .serie_card_details .row {
  color: #FFFFFF;
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.series_container .series_content .series_cards .serie_card .serie_card_details .row .edit {
  font-size: 1.1rem;
  cursor: pointer;
}
.series_container .series_content .series_cards .serie_card .serie_card_details .row .edit:hover {
  color: #cacaca;
}
.series_container .series_content .series_cards .serie_card:hover .serie_card_details {
  bottom: 0;
}
.series_container .add_serie_modale {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(26, 23, 28, 0.5411764706);
}
.series_container .add_serie_modale .add_serie_modale_content {
  width: 55.1875rem;
  height: 27.875rem;
  background-color: #231B27;
  padding: 2rem;
  border-radius: 0.8rem;
  font-size: 80%;
}
.series_container .add_serie_modale .add_serie_modale_content h2 {
  color: #FFFFFF;
  font-size: 1.4rem;
  font-weight: 500;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form {
  width: 100%;
  height: 18rem;
  display: flex;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left {
  width: 60%;
  height: 20rem;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin: 1.8rem 0;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block label {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 400;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block input,
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block select {
  width: 95%;
  padding: 0.6rem;
  outline: none;
  border: 2px solid rgba(255, 255, 255, 0.6980392157);
  color: rgba(255, 255, 255, 0.6980392157);
  background-color: #231B27;
  border-radius: 0.4rem;
  font-size: 1rem;
  font-weight: 600;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block input::placeholder,
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block select::placeholder {
  color: rgba(255, 255, 255, 0.6980392157);
  font-size: 1.1rem;
  font-weight: 400;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block .upload {
  cursor: pointer;
  padding-left: 2.5rem;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block .pdf_file {
  display: none;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block #file_pdf_block {
  position: relative;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block #file_pdf_block .upload_icon {
  position: absolute;
  left: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #775DA6;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block .add_user {
  display: block;
  margin: 1rem auto;
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  outline: none;
  border: 1px solid #92124A;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: #FFFFFF;
  cursor: pointer;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_left .input_block .add_user:hover {
  background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_right {
  width: 40%;
  height: 20rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_right .users_block {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.2rem;
  margin-top: 3rem;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_right .users_block .user_added {
  width: 3rem;
  height: 3rem;
  background-color: #898989;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 700;
  position: relative;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_right .users_block .user_added .delete_user {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem;
  font-weight: 700;
  border-radius: 50%;
  background-color: rgb(251, 152, 152);
  color: rgb(214, 45, 45);
  cursor: pointer;
  opacity: 0;
  transition: 0.2s linear;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form .add_serie_form_right .users_block .user_added .delete_user:hover {
  opacity: 1;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns {
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns button {
  width: 6rem;
  height: 3rem;
  font-size: 1rem;
  font-weight: 600;
  background: rgba(56, 47, 61, 0.6509803922);
  color: #FFFFFF;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.1490196078);
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.2s linear;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns button:hover {
  background-color: #775DA6;
  color: rgba(255, 255, 255, 0.6980392157);
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns #cree {
  width: 10rem;
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  color: rgba(255, 255, 255, 0.6980392157);
  position: relative;
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns #cree:hover {
  background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);
}
.series_container .add_serie_modale .add_serie_modale_content .add_serie_form_btns #cree .create_spin {
  position: absolute;
  left: 1rem;
  top: 35%;
  transform: translateY(-20%);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: detecting 1s linear infinite;
}

@keyframes onCreateCard {
  from {
    transform: translateY(0.8rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes detecting {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/serie/_Series.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AAEI;EACI,WAAA;EACA,kCAAA;EACA,aAAA;AAAR;AAGQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADZ;AAIY;EACI,UAAA;EACA,gBAAA;AAFhB;AAKY;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAHhB;AAKgB;EACI,yBAAA;EACA,uBAAA;AAHpB;AAQQ;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AANZ;AAQY;EACI,WAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AANhB;AAQgB;EACI,cAAA;AANpB;AAUY;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;AARhB;AAYQ;EACI,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAVZ;AAYY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAVhB;AAYgB;EACI,yBAAA;EACA,uBAAA;EACA,iBAAA;AAVpB;AAagB;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AAXpB;AAeY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAbhB;AAegB;EACI,cAAA;EAEA,iBAAA;AAdpB;AAiBgB;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAfpB;AAmBY;EACI,UAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,qBAAA;EACA,WAAA;AAlBhB;AAoBgB;EACI,cAAA;EAEA,mBAAA;EACA,qBAAA;EACA,cAAA;AAnBpB;AAqBoB;EACI,uBAAA;AAnBxB;AAwBY;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EAEA,qBAAA;EACA,WAAA;AAvBhB;AAyBgB;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;AAvBpB;AA6BI;EACI,UAAA;EACA,cAAA;EACA,eAAA;AA3BR;AA6BQ;EACI,cAAA;EACA,cAAA;EACA,eAAA;AA3BZ;AA8BQ;EACI,WAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;AA5BZ;AA8BY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AA5BhB;AA8BgB;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AA5BpB;AA8BoB;EACI,uBAAA;AA5BxB;AAiCgB;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA/BpB;AAmCY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AAjChB;AAmCgB;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;AAjCpB;AAoCgB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AAlCpB;AAoCoB;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AAlCxB;AAoCwB;EACI,iBAAA;EACA,eAAA;AAlC5B;AAoC4B;EACI,cAAA;AAlChC;AAwCgB;EACI,SAAA;AAtCpB;AA4CI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AA1CR;AA6CQ;EACI,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;AA3CZ;AA6CY;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AA3ChB;AA8CY;EACI,WAAA;EACA,aAAA;EACA,aAAA;AA5ChB;AA8CgB;EACI,UAAA;EACA,aAAA;AA5CpB;AA8CoB;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AA5CxB;AA8CwB;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AA5C5B;AA+CwB;;EAEI,UAAA;EACA,eAAA;EACA,aAAA;EACA,mDAAA;EACA,wCAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AA7C5B;AA+C4B;;EACI,wCAAA;EACA,iBAAA;EACA,gBAAA;AA5ChC;AAgDwB;EACI,eAAA;EACA,oBAAA;AA9C5B;AAiDwB;EACI,aAAA;AA/C5B;AAkDwB;EACI,kBAAA;AAhD5B;AAkD4B;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;AAhDhC;AAoDwB;EACI,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,6DAAA;EACA,cAAA;EACA,eAAA;AAlD5B;AAoD4B;EACI,6DAAA;AAlDhC;AAyDgB;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AAvDpB;AA2DoB;EACI,aAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAzDxB;AA4DwB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,kBAAA;AA3D5B;AA8D4B;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;AA5DhC;AA8DgC;EACI,UAAA;AA5DpC;AAsEY;EACI,eAAA;EACA,aAAA;EACA,8BAAA;AApEhB;AAsEgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AApEpB;AAsEoB;EACI,yBAAA;EACA,wCAAA;AApExB;AAwEgB;EACI,YAAA;EACA,6DAAA;EACA,wCAAA;EACA,kBAAA;AAtEpB;AAwEoB;EACI,6DAAA;AAtExB;AAyEoB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;AAvExB;;AA+EA;EACI;IACI,6BAAA;IACA,UAAA;EA5EN;EA+EE;IACI,wBAAA;IACA,UAAA;EA7EN;AACF;AAgFA;EACI;IACI,uBAAA;EA9EN;EAiFE;IACI,yBAAA;EA/EN;AACF","sourcesContent":[".series_container {\n    width: 100%;\n    min-height: 100vh;\n    background-color: #151018;\n    position: relative;\n    // border: 1px solid red;\n\n    .series_header {\n        width: 100%;\n        padding: 2rem 1.5rem .2rem 1.5rem;\n        display: flex;\n        // border: 1px solid green;\n\n        .series_logo {\n            width: 15%;\n            display: flex;\n            align-items: center;\n            position: relative;\n            // border: 1px solid red;\n\n            img{\n                width: 30%;\n                margin-left: 30%;\n            }\n\n            .back {\n                position: absolute;\n                right: .4rem;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 46.34px;\n                height: 46.34px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                color: #FFFFFF;\n                background-color: #231B27;\n                border: 1px solid #231B27;\n                border-radius: .4rem;\n\n                &:hover {\n                    background-color: #2a202e;\n                    color: rgb(214, 65, 10);\n                }\n            }\n        }\n\n        .series_search {\n            width: 70%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: relative;\n\n            input {\n                width: 100%;\n                padding: .48rem 3rem;\n                outline: none;\n                background-color: #231B27;\n                border-radius: .6rem;\n                border: 1px solid #231B27;\n                color: #FFFFFF;\n                font-size: 1.2rem;\n\n                &::placeholder {\n                    color: #898989;\n                }\n            }\n\n            span{\n                position: absolute;\n                display: flex;\n                left: .5rem;\n                top: 50%;\n                transform: translateY(-50%);\n                font-size: 1.8rem;\n                color: #9c9c9c;\n            }\n        }\n\n        .series_avatar {\n            width: 15%;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            gap: 1rem;\n            padding-left: .5rem;\n            position: relative;\n            user-select: none;\n\n            .avatar {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #bababa;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                position: relative;\n                transition: .1s linear;\n\n                &:hover {\n                    background-color: #e8e5e5;\n                    color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n\n                .org{\n                    position: absolute;\n                    color: #e8e5e5;\n                    font-size: .8rem;\n                    text-transform: capitalize;\n                    font-family: \"wildjess\";\n                    top: -1.5rem;\n                    left: 50%;\n                    transform: translateX(-50%);\n                }\n            }\n\n            .notif {\n                width: 3.313rem;\n                height: 3.313rem;\n                background-color: #231B27;\n                color: #e8e5e5;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.3rem;\n                font-weight: 700;\n                cursor: pointer;\n                position: relative;\n                transition: .1s linear;\n\n                &:hover {\n                    color: #D91D6F;\n                    // color: rgb(214, 65, 10);\n                    font-size: 1.5rem;\n                }\n\n                .num_of_notifs{\n                    width: 1.2rem;\n                    height: 1.2rem;\n                    border-radius: 50%;\n                    background-color: #bd2969;\n                    position: absolute;\n                    top: -.3rem;\n                    left: 80%;\n                    transform: translateX(-50%);\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: .8rem;\n                    color: black;\n                }\n            }\n\n            .sub_list {\n                width: 80%;\n                margin: 0 auto;\n                padding: 1rem .2rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -6.5rem;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .item {\n                    display: block;\n                    // text-align: center;\n                    margin: .4rem 1rem;\n                    text-decoration: none;\n                    color: #FFFFFF;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                    }\n                }\n            }\n\n            .notif_list {\n                width: 120%;\n                height: 50vh;\n                margin: 0 auto;\n                padding: 1rem .6rem;\n                background-color: #231B27;\n                position: absolute;\n                bottom: -50vh;\n                left: -40%;\n                display: flex;\n                flex-direction: column;\n                gap: .2rem;\n                overflow-x: hidden;\n                overflow-y: auto;\n                // bottom: 0;\n                border-radius: .6rem;\n                z-index: 10;\n\n                .nofit_item{\n                    display: block;\n                    width: 100%;\n                    font-size:.6rem ;\n                    color: #e8e5e5;\n                    padding: .8rem .6rem;\n                    background-color: #bd2969;\n                }\n            }\n        }\n    }\n\n    .series_content {\n        width: 70%;\n        margin: 0 auto;\n        padding: 0 1rem;\n\n        h2 {\n            color: #FFFFFF;\n            margin: 3rem 0;\n            font-size: 2rem;\n        }\n\n        .series_cards {\n            width: 100%;\n            padding: 1.5rem 1rem;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: flex-start;\n            gap: 2rem;\n\n            .add_serie_card {\n                width: 17rem;\n                height: 25rem;\n                border: 1px solid #FFFFFF;\n                border-radius: 1.25rem;\n                cursor: pointer;\n\n                .add_serie_icon {\n                    width: 17rem;\n                    height: 15rem;\n                    color: #FFFFFF;\n                    justify-content: center;\n                    align-items: center;\n                    font-size: 12rem;\n                    display: flex;\n                    transition: .2s linear;\n\n                    &:hover {\n                        color: rgb(214, 65, 10);\n                        ;\n                    }\n                }\n\n                .add_serie_text {\n                    width: 17rem;\n                    height: 8rem;\n                    padding: 1rem;\n                    color: #FFFFFF;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    font-weight: 400;\n                }\n            }\n\n            .serie_card {\n                width: 17rem;\n                height: 25rem;\n                border: 1px solid #FFFFFF;\n                border-radius: 1.25rem;\n                background-color: rgb(255, 199, 96);\n                font-size: 1.5rem;\n                font-weight: 700;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                overflow: hidden;\n                position: relative;\n                animation: onCreateCard .5s forwards ease-in;\n\n                a {\n                    display: flex;\n                    width: 17rem;\n                    height: 25rem;\n                    justify-content: center;\n                    align-items: center;\n                    text-decoration: none;\n                    text-align: center;\n                    color: rgb(203, 57, 4);\n                }\n\n                .serie_card_details {\n                    width: 17rem;\n                    height: 10rem;\n                    padding-top: .5rem;\n                    background: #2e2c34bc;\n                    position: absolute;\n                    bottom: -12rem;\n                    transition: .2s linear;\n\n                    .row {\n                        color: #FFFFFF;\n                        font-size: 1rem;\n                        font-weight: 400;\n                        display: flex;\n                        justify-content: space-between;\n                        padding: 0.5rem 1rem;\n\n                        .edit {\n                            font-size: 1.1rem;\n                            cursor: pointer;\n\n                            &:hover {\n                                color: #cacaca;\n                            }\n                        }\n                    }\n                }\n\n                &:hover .serie_card_details {\n                    bottom: 0;\n                }\n            }\n        }\n    }\n\n    .add_serie_modale {\n        width: 100%;\n        height: 100vh;\n        position: fixed;\n        top: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #1a171c8a;\n        // display: none;\n\n        .add_serie_modale_content {\n            width: 55.1875rem;\n            height: 27.875rem;\n            background-color: #231B27;\n            padding: 2rem;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            h2 {\n                color: #FFFFFF;\n                font-size: 1.4rem;\n                font-weight: 500;\n            }\n\n            .add_serie_form {\n                width: 100%;\n                height: 18rem;\n                display: flex;\n\n                .add_serie_form_left {\n                    width: 60%;\n                    height: 20rem;\n\n                    .input_block {\n                        display: flex;\n                        flex-direction: column;\n                        gap: .1rem;\n                        margin: 1.8rem 0;\n\n                        label {\n                            color: #FFFFFFB2;\n                            font-size: 1.1rem;\n                            font-weight: 400;\n                        }\n\n                        input,\n                        select {\n                            width: 95%;\n                            padding: .6rem;\n                            outline: none;\n                            border: 2px solid #FFFFFFB2;\n                            color: #FFFFFFB2;\n                            background-color: #231B27;\n                            border-radius: .4rem;\n                            font-size: 1rem;\n                            font-weight: 600;\n\n                            &::placeholder {\n                                color: #FFFFFFB2;\n                                font-size: 1.1rem;\n                                font-weight: 400;\n                            }\n                        }\n\n                        .upload {\n                            cursor: pointer;\n                            padding-left: 2.5rem;\n                        }\n\n                        .pdf_file {\n                            display: none;\n                        }\n\n                        #file_pdf_block {\n                            position: relative;\n\n                            .upload_icon {\n                                position: absolute;\n                                left: .8rem;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                font-size: 1.2rem;\n                                color: #775DA6;\n                            }\n                        }\n\n                        .add_user {\n                            display: block;\n                            margin: 1rem auto;\n                            padding: .5rem .8rem;\n                            border-radius: .5rem;\n                            outline: none;\n                            border: 1px solid #92124A;\n                            background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                            color: #FFFFFF;\n                            cursor: pointer;\n\n                            &:hover {\n                                background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);\n                            }\n                        }\n\n                    }\n                }\n\n                .add_serie_form_right {\n                    width: 40%;\n                    height: 20rem;\n                    display: flex;\n                    justify-content: flex-start;\n                    align-items: center;\n                    // border: 1px solid green;\n\n\n                    .users_block{\n                        display: flex;\n                        justify-content: flex-start;\n                        flex-wrap: wrap;\n                        gap: .2rem;\n                        margin-top: 3rem;\n                        // border: 1px solid red;\n\n                        .user_added{\n                            width: 3rem;\n                            height: 3rem;\n                            background-color: #898989;\n                            border-radius: 50%;\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                            font-size: 1.2rem;\n                            font-weight: 700;\n                            // cursor: pointer;\n                            position: relative;\n                           \n\n                            .delete_user{\n                                display: flex;\n                                justify-content: center;\n                                align-items: center;\n                                position: absolute;\n                                top: 50%;\n                                left: 50%;\n                                transform: translate(-50%, -50%);\n                                width: 3rem;\n                                height: 3rem;\n                                font-size: 1.2rem;\n                                font-weight: 700;\n                                border-radius: 50%;\n                                background-color: rgb(251, 152, 152);\n                                color: rgb(214, 45, 45);\n                                cursor: pointer;\n                                opacity: 0;\n                                transition: .2s linear;\n\n                                &:hover{\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n\n                    \n                }\n            }\n\n            .add_serie_form_btns {\n                padding: 1rem 0;\n                display: flex;\n                justify-content: space-between;\n\n                button {\n                    width: 6rem;\n                    height: 3rem;\n                    font-size: 1rem;\n                    font-weight: 600;\n                    background: #382F3DA6;\n                    color: #FFFFFF;\n                    outline: none;\n                    border: 1px solid #FFFFFF26;\n                    border-radius: .5rem;\n                    cursor: pointer;\n                    transition: .2s linear;\n\n                    &:hover {\n                        background-color: #775DA6;\n                        color: #FFFFFFB2;\n                    }\n                }\n\n                #cree {\n                    width: 10rem;\n                    background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    color: #FFFFFFB2;\n                    position: relative;\n\n                    &:hover {\n                        background: linear-gradient(180deg, #D91D6F 100%, #92124A 0%);\n                    }\n\n                    .create_spin{\n                        position: absolute;\n                        left: 1rem;\n                        top: 35%;\n                        transform: translateY(-20%);\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        animation: detecting 1s linear infinite;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@keyframes onCreateCard {\n    from {\n        transform: translateY(.8rem);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes detecting {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
